module.exports = __webpack_public_path__ + "img/b2b-navbar-logo.670e2298.png";